import { Input } from 'antd5';
import styled, { css } from 'styled-components';

import { Theme } from 'utils/color/horizonTheme';

/** Leaf module — avoids AssetFilter ↔ filters.style circular import. */
export const CustomFilterPopover = styled.div<{ $width?: string; $maxHeight?: number }>`
  &:not(.ant-table-filter-dropdown-checkboxes) {
    min-width: 18rem;
    max-width: 32rem;
  }
  ${({ $width }) => ($width ? `width: ${$width}` : '')};
  ${({ $maxHeight }) =>
    $maxHeight != null
      ? css`
          display: flex;
          flex-direction: column;
          max-height: ${$maxHeight}px;
          overflow: hidden;
        `
      : ''}

  ${({ theme }) =>
    theme.themeName === Theme.Dark
      ? css`
          background-color: ${theme.tertiaryBackgroundColor} !important;
        `
      : ''}
`;

export const FilterSearchInput = styled(Input)`
  && .ant-input-suffix {
    color: ${({ theme }) => theme.secondaryTextColor};
    opacity: 0.45;
  }

  && .ant-input-suffix .anticon-search {
    color: inherit;
    font-size: 12px;
    pointer-events: none;
  }

  && .ant-input-clear-icon {
    color: ${({ theme }) => theme.secondaryTextColor};

    &:hover {
      color: ${({ theme }) => theme.headerColor};
    }
  }
`;

export const FilterSearchButton = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  color: inherit;
  cursor: pointer;
  display: flex;
  padding: 0;
`;

export const FilterActions = styled.div.attrs({
  className: 'ant-table-filter-dropdown-btns',
})`
  border-top: 1px solid ${({ theme }) => theme.borderAccentColor};
`;
